import { render, staticRenderFns } from "./PremiumRestrictedAction.html?vue&type=template&id=c1ba5384&"
import script from "./PremiumRestrictedAction.js?vue&type=script&lang=js&"
export * from "./PremiumRestrictedAction.js?vue&type=script&lang=js&"
import style0 from "./PremiumRestrictedAction.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports